import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import List from "./List";
import Flow from "./Flow";

function Flows(props) {
    return (
        <Switch>
            <Route exact path="/settings/flows" component={List} />
            <Route
                exact
                path="/settings/flows/add"
                render={(props) => <Flow {...props} mode="add" title="" />}
            />
            <Route
                exact
                path="/settings/flows/:id"
                render={(props) => <Flow {...props} mode="detail" title="" />}
            />
            <Route
                exact
                path="/settings/flows/:id/update"
                render={(props) => <Flow {...props} mode="update" title="" />}
            />
        </Switch>
    );
}

export default withRouter(Flows);
